export const SLUGS_WITH_MONETIZABLE_FILTER = [
  'high-yield-online-savings-accounts',
  'savings-accounts',
];

export const HYSA_SLUG = 'high-yield-online-savings-accounts';
